import { render, staticRenderFns } from "./telVerify.vue?vue&type=template&id=64fd727e&scoped=true&"
import script from "./telVerify.vue?vue&type=script&lang=js&"
export * from "./telVerify.vue?vue&type=script&lang=js&"
import style0 from "./telVerify.vue?vue&type=style&index=0&id=64fd727e&lang=less&scoped=true&"
import style1 from "./telVerify.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd727e",
  null
  
)

export default component.exports